import React from 'react'

export default function hrmsReports() {
  return (
    <div>hrmsReports</div>
  )
}

